import headerNavigation from '../../../../musees-de-sete/resources/assets/scripts/regions/header-navigation.js';

export default {
    init() {
        const header = document.querySelector('header');
        const player = document.querySelector('.audio-player');
        const hero = document.querySelector('.homepage-header');
        const body = document.body;
        const isSearchPage = document.body.classList.contains('search');
        const button = document.querySelectorAll('.menu-item, .searchTrigger');
        const burgerTrigger = document.querySelector('.header-burger button');
        const mobileMediaQuery = window.matchMedia('(max-width: 960px)');
        let lastScrollTop = window.scrollY || document.documentElement.scrollTop || 0;

        if (!header || !body || isSearchPage) {
            return;
        }
        const isHome = header.dataset.isFrontPage === 'true';
        if (!isHome) {
            header.classList.remove('is-top');
        }

        if (isHome) {
            header.classList.add('is-top');

            

            burgerTrigger?.addEventListener('click', () => {
                header.classList.remove('is-scroll-down');
                body.classList.remove('is-scroll-down');
            });

            // window.addEventListener('scroll', () => {
            //     const heroBottom = hero.getBoundingClientRect().bottom
            //     console.log(heroBottom)

            //     if(heroBottom <= 0) {
            //         player.classList.remove('is-hidden')
            //     }else {
            //         player.classList.add('is-hidden')
            //     }
            // })
        }

        const resetNavigation = () => {
            if (typeof headerNavigation?.resetNavigation === 'function') {
                headerNavigation.resetNavigation();
            }
        };

        let searchIsActive = false;

        const isNavOpen = () => {
            const hasActiveMenu = document.querySelector('.menu-item.is-active');
            const hasActiveSearchTrigger = document.querySelector('.searchTrigger.is-active');
            return !!(hasActiveMenu || hasActiveSearchTrigger || searchIsActive);
        };

        const updateHeaderTopState = () => {
            if (searchIsActive) {
                header.classList.remove('is-top');
                return;
            }
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const isAtTop = scrollTop <= 200;
            const shouldBeTop = isHome && isAtTop && !isNavOpen();
            header.classList.toggle('is-top', shouldBeTop);
        };

        const updateMobileScrollState = () => {
            if (!mobileMediaQuery.matches || isNavOpen()) {
                header.classList.remove('is-scroll-down');
                body.classList.remove('is-scroll-down');
                lastScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
                return;
            }

            const scrollTop = Math.max(window.scrollY || document.documentElement.scrollTop || 0, 0);
            const scrollDelta = scrollTop - lastScrollTop;

            if (Math.abs(scrollDelta) < 10) {
                return;
            }

            if (scrollDelta > 0 && scrollTop > 80) {
                header.classList.add('is-scroll-down');
                body.classList.add('is-scroll-down');
            } else {
                header.classList.remove('is-scroll-down');
                body.classList.remove('is-scroll-down');
            }

            lastScrollTop = scrollTop;
        };

        const updateHeaderState = () => {
            updateHeaderTopState();
            updateMobileScrollState();
        };

        window.addEventListener('scroll', () => {
            updateHeaderState();
            if (!document.querySelector('.search-container.is-active')) {
                resetNavigation();
            }
        });

        mobileMediaQuery.addEventListener('change', () => {
            header.classList.remove('is-scroll-down');
            body.classList.remove('is-scroll-down');
            lastScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
            updateHeaderState();
        });

        button.forEach((els) => {
            els.addEventListener('click', () => {
                updateHeaderState();
                header.classList.remove('is-scroll-down');
                body.classList.remove('is-scroll-down');
            });
        });

        updateHeaderState();

        const searchContainer = document.querySelector('.search-container');
        if (searchContainer) {
            new MutationObserver(() => {
                searchIsActive = searchContainer.classList.contains('is-active');
                updateHeaderTopState();
            }).observe(searchContainer, { attributes: true, attributeFilter: ['class'] });
        }
    },

};
